import { Link } from "react-router-dom";
import type { Article } from "@/types/content";

interface JournalCardProps {
  article: Article;
  /** visual ratio for the masonry rhythm */
  ratio?: "tall" | "wide" | "square";
}

const ratioClass: Record<string, string> = {
  tall: "aspect-[3/4]",
  wide: "aspect-[4/3]",
  square: "aspect-square",
};

export default function JournalCard({ article, ratio = "wide" }: JournalCardProps) {
  return (
    <article className="group">
      <Link
        to={`/journal/${article.slug}`}
        className="block overflow-hidden image-zoom"
        aria-label={`Read: ${article.title}`}
      >
        <div
          className={`relative w-full overflow-hidden bg-foreground-900 ${ratioClass[ratio]}`}
        >
          <img
            src={article.image}
            alt={article.title}
            title={`${article.title} — Chef's Table journal`}
            className="h-full w-full object-cover"
          />
          <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 font-label text-[10px] uppercase tracking-label text-foreground-950">
            {article.category}
          </span>
        </div>
      </Link>

      <div className="mt-5">
        <div className="flex items-center gap-3 font-label text-[10px] uppercase tracking-label text-foreground-500">
          <span>{article.date}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300" />
          <span>{article.readTime} read</span>
        </div>
        <h3 className="mt-3 font-heading text-xl leading-snug text-foreground-950 transition-colors duration-300 group-hover:text-primary-600 md:text-2xl">
          {article.title}
        </h3>
        <p className="mt-2 font-body text-sm leading-relaxed text-foreground-700">
          {article.excerpt}
        </p>
      </div>
    </article>
  );
}